import Glide from '@glidejs/glide';
import merge from 'lodash/merge';
import objectParser from '../utils/object-parser';
import breakpoints from '../breakpoints';

function DisableControls(Glide, Components, Events) {
  const PREV_CONTROL_SELECTOR = "[data-glide-dir='|<']";
  const NEXT_CONTROL_SELECTOR = "[data-glide-dir='|>']";
  const component = {
    buildAfter() {
      this.prevBtn = Components.Html.root.querySelector(PREV_CONTROL_SELECTOR);
      this.nextBtn = Components.Html.root.querySelector(NEXT_CONTROL_SELECTOR);
    },
    handleDisable() {
      const { perView, rewind } = Glide.settings;
      const slidesCount = Components.Html.slides.length;
      const isFullyDisabled = slidesCount <= perView;

      if (!rewind) {        
        this.prevBtn.disabled = (Glide.index <= 0) || isFullyDisabled;
        this.nextBtn.disabled = (Glide.index >= slidesCount - perView) || isFullyDisabled;
      } else {
        this.prevBtn.disabled = this.nextBtn.disabled = isFullyDisabled;
      }

      if(isFullyDisabled) {
        Glide.disable();
      } else {
        Glide.enable();
      }
    },
  };

  Events.on("build.after", function () {
    component.buildAfter();
    component.handleDisable();
  });

  Events.on("run.after", function () {
    component.handleDisable();
  });

  return component;
}

function initScroller(el) {
  const DEFAULTS = {
    type: 'slider',
    perView: 3,
    gap: 20,
    classes: {
      type: {
        slider: 'is-init',
        carousel: 'is-init'
      },
      direction: {
        ltr: 'is-ltr',
        rtl: 'is-rtl'
      },
      swipeable: 'is-swipeable',
      dragging: 'is-dragging',
      nav: {
        active: "is-active"
      },
      slide: {
        active: 'is-active',
        clone: 'is-clone'
      },
      arrow: {
        disabled: 'is-disabled'
      }
    },
    breakpoints: {
      [breakpoints.large - 1]: {
        perView: 2,
      },
      [breakpoints.medium - 1]: {
        perView: 2,
      },
    }
  };
  const { options } = objectParser(el.dataset);
  const settings = merge( {}, DEFAULTS, options);

  function GlideWrapper() {
    if(el.glide) {
      el.glide.destroy();
    }

    this.isMounted = false;
    this.glide = new Glide(el, settings);
    this.glide.on('mount.after', () => {
      this.isMounted = true;
    });
         
    el.glide = this.glide;
  }

  if( settings.breakpoint ) {
    let instance = new GlideWrapper();
    const breakpoint = breakpoints[settings.breakpoint];
    const mq = window.matchMedia(`(min-width: ${breakpoint}px)`);

    function handleMediaQueryChange(mq) {
      if(mq.matches) {
        if(!instance) {
          instance = new GlideWrapper();
        }

        instance.glide.mount({ DisableControls }); 
      } else {
        instance.glide.destroy();
        instance = null;
      }
    }
  
    handleMediaQueryChange(mq);
    mq.addEventListener('change', handleMediaQueryChange );
  } else {
    new GlideWrapper().glide.mount({ DisableControls });
  }
}

window.initScroller = initScroller;

document.querySelectorAll('.js-Scroller').forEach(el => initScroller(el))



